/**
 * Multi-domain access control for the front bundle.
 *
 * The same build can be served from several public domains (e.g.
 * apy.xxx.com / apy.yyy.com). VITE_ALLOWED_ORIGINS lists the ones we accept;
 * anything else is blocked at boot with a dedicated screen.
 *
 * This is defense-in-depth — Azure AD redirect URIs and boost-core CORS
 * remain the real authorization barriers.
 */

function getAllowedOrigins(): string[] {
  const raw = import.meta.env.VITE_ALLOWED_ORIGINS as string | undefined
  if (!raw) return []
  return raw.split(',').map((o) => o.trim()).filter(Boolean)
}

export function isOriginAllowed(): boolean {
  const allowed = getAllowedOrigins()
  // Dev convenience: no whitelist configured → allow (localhost, preview…)
  if (allowed.length === 0) return import.meta.env.DEV
  return allowed.includes(window.location.origin)
}
